import LegalLayout, { Section } from "@/components/jobbkarta/LegalLayout";
import { CONTACT_EMAIL } from "@/components/jobbkarta/Footer";

const UPDATED = "12 oktober 2026";

export default function Privacy() {
  return (
    <LegalLayout title="Integritetspolicy" updated={UPDATED} testid="page-privacy">
      <p>
        Din integritet är viktig för oss. Den här policyn förklarar vilka
        personuppgifter Spontan. behandlar, varför, och vilka rättigheter du har.
        Spontan. är personuppgiftsansvarig för behandlingen.
      </p>

      <Section heading="Du behöver inget konto">
        <p>
          Du kan använda Spontan. utan att registrera dig eller logga in. Vi
          skapar inga användarkonton och lagrar inga lösenord.
        </p>
      </Section>

      <Section heading="Vilka uppgifter vi behandlar">
        <ul className="list-disc space-y-1 pl-5">
          <li>
            <strong>Sökningar.</strong> När du söker på en stad hämtar vi öppna
            uppgifter om företag och lediga jobb från Arbetsförmedlingen och
            OpenStreetMap. Sökningen sparas tillfälligt för att kunna visa
            resultatet och raderas automatiskt efter en kort tid.
          </li>
          <li>
            <strong>Din profil.</strong> De uppgifter du fyller i om dig själv
            (t.ex. namn och erfarenhet) för att skapa ansökningsmail sparas
            endast lokalt i din webbläsare och skickas inte till oss för lagring.
          </li>
          <li>
            <strong>AI-genererat mail.</strong> När du ber appen skriva ett mail
            skickas de uppgifter du angett tillsammans med information om
            företaget till vår AI-leverantör för att generera texten. Vi sparar
            inte mailen.
          </li>
          <li>
            <strong>Köp.</strong> När du köper Uppföljningsguiden hanteras
            betalningen av Stripe. Vi tar emot din e-postadress för att skicka
            kvitto och själva guiden, samt uppgift om att betalningen genomförts.
            Vi ser aldrig dina fullständiga kortuppgifter.
          </li>
        </ul>
      </Section>

      <Section heading="Varför vi behandlar uppgifterna (rättslig grund)">
        <ul className="list-disc space-y-1 pl-5">
          <li>För att leverera tjänsten du efterfrågar (fullgörande av avtal).</li>
          <li>För att genomföra köp och skicka kvitto (fullgörande av avtal samt rättslig förpliktelse för bokföring).</li>
          <li>För att driva och förbättra tjänsten samt förhindra missbruk (berättigat intresse).</li>
        </ul>
      </Section>

      <Section heading="Mottagare och underleverantörer">
        <p>
          Vi delar uppgifter endast med de leverantörer som krävs för att driva
          tjänsten: betalleverantören Stripe, vår e-postleverantör för utskick av
          kvitto, samt vår AI-leverantör för att skapa ansökningsmail. Dessa
          behandlar uppgifter enligt egna villkor och endast på vårt uppdrag.
        </p>
      </Section>

      <Section heading="Lagringstid">
        <p>
          Sökdata raderas automatiskt efter kort tid. Uppgifter kopplade till köp
          sparas så länge som krävs enligt bokföringslagen (normalt sju år).
          Din profil ligger kvar i din webbläsare tills du rensar den.
        </p>
      </Section>

      <Section heading="Dina rättigheter">
        <p>
          Du har rätt att begära tillgång till, rättelse eller radering av dina
          personuppgifter, samt att invända mot eller begränsa behandlingen. Du
          har även rätt att lämna klagomål till Integritetsskyddsmyndigheten
          (IMY). Kontakta oss på{" "}
          <a className="font-medium text-emerald-700 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>{" "}
          så hjälper vi dig.
        </p>
      </Section>

      <Section heading="Cookies">
        <p>
          Läs mer om hur vi använder cookies och liknande tekniker på vår{" "}
          <a className="font-medium text-emerald-700 hover:underline" href="/cookies">
            cookiesida
          </a>
          .
        </p>
      </Section>

      <Section heading="Kontakt">
        <p>
          Har du frågor om hur vi behandlar dina uppgifter? Mejla oss på{" "}
          <a className="font-medium text-emerald-700 hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
